import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../core/Evented.js";
import e from "../../../core/has.js";
import { isNone as s } from "../../../core/maybe.js";
import { createResolver as i } from "../../../core/promiseUtils.js";
var r = 1 / e("mapview-transitions-duration");

var a = /*#__PURE__*/function (_t) {
  _inherits(a, _t);

  var _super = _createSuper(a);

  function a() {
    var _this;

    _classCallCheck(this, a);

    _this = _super.apply(this, arguments), _this._fadeOutResolver = null, _this._fadeInResolver = null, _this._clips = null, _this.computedVisible = !0, _this.computedOpacity = 1, _this.fadeTransitionEnabled = !1, _this.inFadeTransition = !1, _this._isReady = !1, _this._opacity = 1, _this._stage = null, _this._visible = !0;
    return _this;
  }

  _createClass(a, [{
    key: "clips",
    get: function get() {
      return this._clips;
    },
    set: function set(t) {
      this._clips = t, this.requestRender();
    }
  }, {
    key: "isReady",
    get: function get() {
      return this._isReady;
    }
  }, {
    key: "opacity",
    get: function get() {
      return this._opacity;
    },
    set: function set(t) {
      this._opacity !== t && (this._opacity = Math.min(1, Math.max(t, 0)), this.requestRender());
    }
  }, {
    key: "stage",
    get: function get() {
      return this._stage;
    },
    set: function set(t) {
      if (this._stage === t) return;
      var e = this._stage;
      this._stage = t, t ? this._stage.untrashDisplayObject(this) || (this.onAttach(), this.emit("attach")) : e.trashDisplayObject(this);
    }
  }, {
    key: "transforms",
    get: function get() {
      return this._getTransforms();
    }
  }, {
    key: "_getTransforms",
    value: function _getTransforms() {
      return s(this._transforms) && (this._transforms = this._createTransforms()), this._transforms;
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    },
    set: function set(t) {
      this._visible !== t && (this._visible = t, this.requestRender());
    }
  }, {
    key: "fadeIn",
    value: function fadeIn() {
      return this._fadeInResolver || (this._fadeOutResolver && (this._fadeOutResolver(), this._fadeOutResolver = null), this.computedOpacity = 0, this.fadeTransitionEnabled = !0, this._fadeInResolver = i(), this.requestRender()), this._fadeInResolver.promise;
    }
  }, {
    key: "fadeOut",
    value: function fadeOut() {
      return this._fadeOutResolver || (this._fadeInResolver && (this._fadeInResolver(), this._fadeInResolver = null), this.fadeTransitionEnabled = !0, this._fadeOutResolver = i(), this.requestRender()), this._fadeOutResolver.promise;
    }
  }, {
    key: "beforeRender",
    value: function beforeRender(t) {
      this.updateTransitionProperties(t.deltaTime, t.state.scale);
    }
  }, {
    key: "afterRender",
    value: function afterRender(t) {
      this._fadeInResolver && this.computedOpacity === this.opacity ? (this._fadeInResolver(), this._fadeInResolver = null) : this._fadeOutResolver && 0 === this.computedOpacity && (this._fadeOutResolver(), this._fadeOutResolver = null);
    }
  }, {
    key: "remove",
    value: function remove() {
      var t;
      null == (t = this.parent) || t.removeChild(this);
    }
  }, {
    key: "setTransform",
    value: function setTransform(t) {}
  }, {
    key: "processRender",
    value: function processRender(t) {
      this.stage && this.computedVisible && this.doRender(t);
    }
  }, {
    key: "requestRender",
    value: function requestRender() {
      this.stage && this.stage.requestRender();
    }
  }, {
    key: "processDetach",
    value: function processDetach() {
      this.onDetach(), this.emit("detach");
    }
  }, {
    key: "updateTransitionProperties",
    value: function updateTransitionProperties(t, e) {
      if (this.fadeTransitionEnabled) {
        var _e = this._fadeOutResolver || !this.visible ? 0 : this.opacity,
            _s = this.computedOpacity;

        if (_s === _e) this.computedVisible = this.visible;else {
          var _i = t * r;

          this.computedOpacity = _s > _e ? Math.max(_e, _s - _i) : Math.min(_e, _s + _i), this.computedVisible = this.computedOpacity > 0;

          var _a2 = _e === this.computedOpacity;

          this.inFadeTransition = !_a2, _a2 || this.requestRender();
        }
      } else this.computedOpacity = this.opacity, this.computedVisible = this.visible;
    }
  }, {
    key: "onAttach",
    value: function onAttach() {}
  }, {
    key: "onDetach",
    value: function onDetach() {}
  }, {
    key: "doRender",
    value: function doRender(t) {}
  }, {
    key: "ready",
    value: function ready() {
      this._isReady || (this._isReady = !0, this.emit("isReady"), this.requestRender());
    }
  }]);

  return a;
}(t);

export { a as DisplayObject };